var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserTieSolid = function SvgUserTieSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#445A64",
    d: "M10 2.929a4.383 4.383 0 0 0-4.375 4.375c0 1.486.757 2.802 1.895 3.593-2.566 1.001-4.395 3.501-4.395 6.407h1.25c0-2.75 1.995-5.047 4.61-5.528l.39 1.153h1.25l.39-1.153c2.615.481 4.61 2.779 4.61 5.528h1.25c0-2.906-1.829-5.406-4.395-6.407a4.38 4.38 0 0 0 1.895-3.593A4.383 4.383 0 0 0 10 2.929m0 1.25a3.115 3.115 0 0 1 3.125 3.125A3.115 3.115 0 0 1 10 10.429a3.115 3.115 0 0 1-3.125-3.125A3.115 3.115 0 0 1 10 4.179m-.625 9.375-.625 3.75h2.5l-.625-3.75z"
  })));
};
export default SvgUserTieSolid;